// extracted by mini-css-extract-plugin
export default {"assistSection":"CustomerSupportAssistOptions_assistSection__Kus20"};